angular.module('baijiahaoServiceModule', []).factory('baijiahaoService', ['$q', 'editIsLock', '$window', 'editingCenterService', 'ueditorService', 'storageListenerService', 'editcenterRightsService',
    function($q, editIsLock, $window, editingCenterService, ueditorService, storageListenerService, editcenterRightsService) {
        return {

            /**
             * [addFuture 为控制器作用域增加通用功能]
             *
             * @param   {[type]}  vm              [vm description]
             * @param   {[type]}  methodNameList  [methodNameList description]
             *
             * @return  {[type]}                  [return description]
             */
            addFuture: function (vm, methodNameList) {
                for (var i = 0; i < methodNameList.length; i++) {
                    let methodName = methodNameList[i];
                    vm[methodName] = this[methodName];
                }
                return vm;
            },

            /**
             * [sendmessage 发送消息到IM]
             *
             * @return  {[type]}  [return description]
             */
            sendmessage: function () {
                let that = this;
                this.save(true).then((data) => {
                    const outerSourceId = that.list.METADATAID;
                    const title = that.list.TITLE;
                    let articleDocType = editingCenterService.getDocTypeId();
                    let articleMediaType = editingCenterService.getEditPageMediaType();
                    let url = getDetailUrl(articleMediaType);
                    const extraInfo = {
                        'articleDocType': articleDocType,
                        'articleMediaType': articleMediaType,
                        'articleUrl': url,
                        'mediatype': articleMediaType,
                        'account': $state.params.baijiahaoaccount,
                        'metadataid': outerSourceId,
                        'chnldocid': that.list.CHNLDOCID,
                        'channelid': that.list.CHANNELID
                    };
                    const info = {
                        messageBody: {
                            content: '',
                            extraInfo: JSON.stringify(extraInfo),
                            messageType: 'ARTICLE_DOC', 
                            outerSourceId: outerSourceId,
                            platform: '',
                            title: title
                        },
                        outerSourceId: '',
                        oprType: getOprType(),
                        objId: $state.params.baijiahaoaccount
                    };
                    editingCenterService.sendToStudio(info).then(function(result){
                        if (result.ISSUCCESS === 'true') {
                            setTimeout(() => {
                                window.close();
                            }, 2000);
                        }
                    });
                });
            },

            initSelect: function() {
                return [
                    {
                        name: '全部稿件',
                        value: '',
                    },
                    {
                        name: '新闻',
                        value: '1',
                    },
                    {
                        name: '图集',
                        value: '2',
                    },
                    {
                        name: '视频',
                        value: '7',
                    },
                ];
            },
            initEditerBtn: function(platform, account, isawaitrevise) {
                var defer = $q.defer();
                var compaildbtn = [
                    {
                        RIGHTINDEX: 901,
                        OPERDESC: '保存',
                        OPERFUN: 'save',
                    },
                    {
                        RIGHTINDEX: 902,
                        OPERDESC: '送审',
                        OPERFUN: 'baijiahaoTrial',
                        rightKey: 'baijiahao.daibian.songshen'
                    },
                    {
                        RIGHTINDEX: 902,
                        OPERDESC: '签发',
                        OPERFUN: 'baijiahaoSign',
                        rightKey: 'baijiahao.daibian.qianfa'
                    },
                ];
                let pendingbtn = [
                    {
                        RIGHTINDEX: 901,
                        OPERDESC: '保存',
                        OPERFUN: 'save',
                    },
                    {
                        RIGHTINDEX: 902,
                        OPERDESC: '撤稿',
                        rightKey: 'baijiahao.daishen.chegao'
                    },
                    {
                        RIGHTINDEX: 902,
                        OPERDESC: '签发',
                        OPERFUN: 'baijiahaoSign',
                        rightKey: 'baijiahao.daishen.qianfa'
                    },
                ];
                var arrayWebsiteBtns = [compaildbtn, pendingbtn];
                editcenterRightsService.initBaiJiaHaoListBtn(['baijiahao.daibian', 'baijiahao.daishen'][platform], account).then(function(rights) {
                    var btns = arrayWebsiteBtns[platform];
                    defer.resolve(btns.filter(function(btn) {
                        return !btn.rightKey || rights[btn.rightKey];
                    }));
                });
                return defer.promise;
            },

            /**
             * [initEditPath:function description]初始化编辑页路径
             * @return  {[type]}  [return description]
             */
            initEditPath: function() {
                var editPath = {
                    1: 'baijiahaonews',
                    2: 'baijiahaoatlas',
                    7: 'baijiahaovideo',
                };
                return editPath;
            },

            /**
             * [baijiahaoEditor description]
             * @param   {[type]}  docType    [docType description]
             * @param   {[type]}  account    [account description]
             * @param   {[type]}  articleid  [articleid description]
             * @param   {[type]}  platform   [platform description]
             * @return  {[type]}             [return description]
             */
            baijiahaoEditor: function(docType, account, articleid, platform) {
                var routerName =
                    '#/' +
                    this.initEditPath()[docType] +
                    '?baijiahaoaccount=' +
                    account +
                    '&baijiahaoarticleid=' +
                    articleid +
                    '&baijiahaoplatform=' +
                    platform;
                editIsLock.isLock({METADATAID: articleid}, 18).then(function (data) {
                    if (data.ISLOCK === 'false') {
                        window.open(routerName);
                    } else {
                        editIsLock.checkUnlockPermissions({METADATAID: articleid}, data).then(function () {
                            window.open(routerName);
                        });
                    }
                });
            },

            /**
             * [baijiahaoUnlock description] 百家号解锁方法
             *
             * @param   {[type]}  form       [form description]
             * @param   {[type]}  list       [list description]
             * @param   {[type]}  save       [save description]
             * @param   {[type]}  articleid  [articleid description]
             *
             * @return  {function}           [return description]
             */
            baijiahaoUnlock: function(form, list, save, articleid) {
                var flag = window.UE ? ueditorService.contentTranscoding(list) !== ueditorService.bindContent() : false;
                editingCenterService
                    .closeWinow(form.$dirty, flag)
                    .then(
                        function() {
                            save().then(function() {
                                // 保存成功后的处理
                                storageListenerService.addListenerToBaijiahao('save');
                                editIsLock.normalLock(articleid).then(function(data) {
                                    $window.close();
                                });
                            });
                        },
                        function() {
                            angular.isDefined(articleid)
                                ? editIsLock.normalLock(articleid).then(function(data) {
                                    $window.close();
                                })
                                : $window.close();
                        }
                    );
            }
        };
    },
]);
